export const IDENTITY_SDK_VERSION = "2.27.0"
